import React from "react";
import { useIntl } from "react-intl";
import { ModalBaseProps } from "../types";
import IconSelector from "../../../atoms/inputs/IconSelector";
import NoFooterModal from "../NoFooterModal";
import { IconName } from "../../../../globalTypes";

type IconPickerModalProps = ModalBaseProps & {
  callbackFnc: (icon: IconName) => void;
};

const IconPickerModal = ({
  isOpen,
  toggleModal,
  callbackFnc,
}: IconPickerModalProps) => {
  const { formatMessage } = useIntl();
  return (
    <NoFooterModal
      isOpen={isOpen}
      toggle={toggleModal}
      title={formatMessage({ id: "segments.chose_icon" })}
    >
      <IconSelector onIconSelect={callbackFnc} />
    </NoFooterModal>
  );
};

export default IconPickerModal;
